import React from "react";
import { Link } from "react-router-dom";
import Gleap from "gleap";

/**
 * Shown when the backend gates a request because the company's CertainPath
 * membership is no longer active (CompanyMembershipInactiveException). The
 * axios interceptor lands here instead of the generic /403 page.
 */
export default function MembershipInactivePage() {
  return (
    <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <p className="text-base font-semibold text-primary">
          Membership inactive
        </p>

        <h1 className="mt-4 text-5xl font-semibold tracking-tight text-secondary sm:text-7xl">
          We&apos;ve missed you
        </h1>

        <p className="mt-6 text-lg text-gray-500">
          Your company&apos;s CertainPath membership is no longer active, so
          access to the Hub is paused. Reach out and we&apos;ll get you going
          again.
        </p>

        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Link
            className="rounded-md bg-primary px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm
                       hover:bg-primary-dark focus-visible:outline
                       focus-visible:outline-2 focus-visible:outline-offset-2
                       focus-visible:outline-primary-dark"
            onClick={() => Gleap.open()}
            to="#"
          >
            Contact CertainPath
          </Link>

          {/* Through /logout, not a raw Auth0 logout — the Logout component
              also clears impersonation metadata, so signing out actually
              ends an impersonation session. */}
          <button
            className="text-sm font-semibold text-primary"
            onClick={() => window.location.assign("/logout")}
            type="button"
          >
            Sign out <span aria-hidden="true">&rarr;</span>
          </button>
        </div>
      </div>
    </main>
  );
}
